import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import styled from 'styled-components';
const Container = styled.span `
  ${fonts.inter.extraBold};

  display: inline-flex;
  align-items: center;
  background: ${brand.primary.blue.base};
  border: ${fluid(1, 2)} solid ${brand.white};
  border-left-width: 0;
  border-bottom-width: 0;
  border-radius: 0 20px 0 0;
  color: ${brand.white};
  font-size: 13px;
  line-height: 1em;
  min-width: 120px;
  padding: 10px 40px 10px 25px;
  text-transform: uppercase;
  white-space: nowrap;
  width: auto;
`;
const TagStyles = {
    Container,
};
export default TagStyles;
